import { PoolConfig, QuoteToken, PoolCategory } from './types'

const pools: PoolConfig[] = [
  // {
  //   sousId: 98, // V1
  //   tokenName: 'BUSD',
  //   tokenLabel: 'BUSD v1',
  //   tokenAddress: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
  //   stakingTokenName: QuoteToken.TAPS,
  //   stakingTokenAddress: '0x56eab07247e3e6404ac90140F20bba61375d5C3C',
  //   stakingTokenDecimals: 18,
  //   contractAddress: {
  //     97: '',
  //     56: '0x600a04123C354D0c462C84BB6FdDE51048Ea1Ef9',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   projectLink: 'https://tapswap.money',
  //   harvest: true,
  //   tokenPerBlock: '0.00744047619',
  //   sortOrder: 999,
  //   isFinished: false,
  //   tokenDecimals: 18,
  //   isBush: true,
  //   isLp: false,
  //   bushVersion: 1,
  //   getUrl: '/#/swap?outputCurrency=0x56eab07247e3e6404ac90140F20bba61375d5C3C',
  // },
  // {
  //   sousId: 99, // V1
  //   tokenName: 'WBNB',
  //   tokenLabel: 'WBNB v1',
  //   tokenAddress: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
  //   stakingTokenName: QuoteToken.TAPS,
  //   stakingTokenAddress: '0x56eab07247e3e6404ac90140F20bba61375d5C3C',
  //   stakingTokenDecimals: 18,
  //   contractAddress: {
  //     97: '',
  //     56: '0x705993A5576c67Ba7d0d1B8a39857AeB28712201',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   projectLink: 'https://www.binance.com',
  //   harvest: true,
  //   tokenPerBlock: '0.00002703373016',
  //   sortOrder: 999,
  //   isFinished: false,
  //   tokenDecimals: 18,
  //   isBush: true,
  //   isLp: false,
  //   bushVersion: 1,
  //   getUrl: '/#/swap?outputCurrency=0x56eab07247e3e6404ac90140F20bba61375d5C3C',
  // },
]

export default pools
